import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "./LoadsNotifications.module.css";
import { useNavigate } from "react-router-dom";

const LoadsNotifications = ({
  initialDelay = 10000, // Prima notificare după 10 secunde
  intervalDelay = 2 * 60 * 1000, // Notificare la fiecare 2 minute
  hideAfter = 5000, // Notificarea dispare după 5 secunde
  resetDelay = 24 * 60 * 60 * 1000, // Resetare după 24 ore
  onNavigateToSection,
}) => {
  const [incompleteLoads, setIncompleteLoads] = useState([]);
  const [currentNotification, setCurrentNotification] = useState(null);
  const [notificationVisible, setNotificationVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchIncompleteLoads = async () => {
      try {
        const token = sessionStorage.getItem("token") || localStorage.getItem("token");
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };

        const response = await axios.get("https://api-backend.full-trucking-service.com/api/loads/incomplete", config);
        setIncompleteLoads(response.data);
      } catch (error) {
        console.error("Error fetching incomplete loads:", error);
      }
    };

    fetchIncompleteLoads();
  }, []);

  useEffect(() => {
    if (incompleteLoads.length === 0) return;

    const showNextNotification = () => {
      const lastNotifiedLoads = JSON.parse(localStorage.getItem("lastNotifiedLoads")) || {};
      const currentTime = new Date().getTime();

      // Filtrăm doar încărcăturile care nu au fost notificate în ultimele 24 de ore
      const loadsToNotify = incompleteLoads.filter((load) => {
        return !lastNotifiedLoads[load._id] || currentTime - lastNotifiedLoads[load._id] > resetDelay;
      });

      if (loadsToNotify.length === 0) return; // Dacă nu avem încărcături noi, ieșim

      const nextLoad = loadsToNotify[0]; // Luăm prima încărcătură disponibilă
      setCurrentNotification(nextLoad);
      setNotificationVisible(true);

      // Salvăm timestamp-ul în localStorage pentru această încărcătură
      lastNotifiedLoads[nextLoad._id] = currentTime;
      localStorage.setItem("lastNotifiedLoads", JSON.stringify(lastNotifiedLoads));

      setTimeout(() => {
        setNotificationVisible(false);
      }, hideAfter);
    };

    const initialTimer = setTimeout(() => {
      showNextNotification();
      const intervalTimer = setInterval(() => {
        showNextNotification();
      }, intervalDelay);

      return () => clearInterval(intervalTimer);
    }, initialDelay);

    return () => clearTimeout(initialTimer);
  }, [incompleteLoads, initialDelay, intervalDelay, hideAfter, resetDelay]);

  const handleCloseNotification = () => {
    setNotificationVisible(false);
  };

  const handleNotificationClick = (loadId) => {
    onNavigateToSection("load-manager", loadId);
    handleCloseNotification();
  };

  if (!notificationVisible || !currentNotification) return null;

  return (
    <div className={styles.loadnotificationContainer}>
      <div
        className={styles.loadnotification}
        onClick={() => handleNotificationClick(currentNotification._id)}
      >
        Load {currentNotification.loadNumber} is still {currentNotification.status} in{' '}
        {currentNotification.shippers?.[0]?.name || 'Unknown Shipper'}.
        <button
          className={styles.loadnotificationcloseButton}
          onClick={(e) => {
            e.stopPropagation();
            handleCloseNotification();
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default LoadsNotifications;
